var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stack',{staticClass:"w-full min-h-32 justify-center items-center align-middle text-center bg-white"},[_vm._t("text",function(){return [_c('span',{staticClass:"font-semibold mb-2"},[_vm._v(" "+_vm._s(_vm.$t("Common.System.loading"))+" ")])]}),_vm._t("icon",function(){return [_c('loading-icon',{attrs:{"icon-class":"icon-6xl"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }